import { useEffect, useState } from 'react';

/**
 * True once the window's load event has fired (or had already fired before
 * the component mounted). Embeds that never settle - an autoplaying YouTube
 * iframe keeps its document request open - hold the load event back for as
 * long as they are in the page, so anything that must wait for load, like
 * the service worker registration and the PWA checks that look for it, never
 * runs. Mounting such embeds only after load keeps them out of its way.
 */
export default function useAfterPageLoad() {
    const [loaded, setLoaded] = useState(() => document.readyState === 'complete');

    useEffect(() => {
        if (loaded) return undefined;
        const onLoad = () => setLoaded(true);
        window.addEventListener('load', onLoad);
        return () => window.removeEventListener('load', onLoad);
    }, [loaded]);

    return loaded;
}
